/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV to JSON Converter — Convert Both Ways | Toolverse`)
};

const es_cj_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor de CSV a JSON — Convierte en ambas direcciones | Toolverse`)
};

const de_cj_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV-zu-JSON-Konverter — Beide Richtungen konvertieren | Toolverse`)
};

const nl_cj_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV naar JSON-converter — Beide richtingen converteren | Toolverse`)
};

const fr_cj_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur CSV en JSON — Convertir dans les deux sens | Toolverse`)
};

const it_cj_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore CSV a JSON — Converti in entrambe le direzioni | Toolverse`)
};

const pt_br2_cj_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de CSV para JSON — Converta nos Dois Sentidos | Toolverse`)
};

const pt_cj_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de CSV para JSON — Converter nos dois sentidos | Toolverse`)
};

const ja_cj_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV から JSON コンバーター — 両方向に変換 | Toolverse`)
};

const zh_cj_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV 转 JSON 转换器——双向转换 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_meta_title", locale)
	if (locale === "en") return en_cj_meta_title(inputs)
	if (locale === "es") return es_cj_meta_title(inputs)
	if (locale === "de") return de_cj_meta_title(inputs)
	if (locale === "nl") return nl_cj_meta_title(inputs)
	if (locale === "fr") return fr_cj_meta_title(inputs)
	if (locale === "it") return it_cj_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_cj_meta_title(inputs)
	if (locale === "pt") return pt_cj_meta_title(inputs)
	if (locale === "ja") return ja_cj_meta_title(inputs)
	return zh_cj_meta_title(inputs)
};